import { Stack } from "@mui/material";
import CollectionFilters from "../pages/filters/CollectionFilters";
import CollectionTable from "../tables/CollectionTable";


function Collections() {

    return (
            <Stack direction={"column"} spacing={2} margin={"16px"}>
                <CollectionFilters/>
                <CollectionTable/> 
            </Stack>
    );
}

export default Collections;